// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4016":"b498039d","6825":"b498039d","8832":"b498039d"}[chunkId] + ".chunk.css";
};